module.exports = __webpack_public_path__ + "static/img/shiprateshop.bef19b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shiprateshop.png
// module id = hO7h
// module chunks = 18